import { gql } from '@apollo/client';

export const sendInvitation = gql`
  mutation sendInvitation($input: InvitationActivityInput!) {
    sendInvitation(input: $input) {
      id
    }
  }
`;
